import { ProductScreenshot } from 'components/ProductScreenshot';
import InboundIpAddresses from "../../../../contents/docs/cdp/_snippets/inbound-ip-addresses.mdx";
import * as React from 'react';
export default {
  ProductScreenshot,
  InboundIpAddresses,
  React
};